import React, { Component } from 'react';
import { connect } from 'dva';
import '@/styles/containers/home/index.less';

import { parse } from "querystring";
import { framework_tool, component_tool } from '@/tool'

let {
  WizLayout
} = component_tool;
const { WizContainer, modelUtils } = framework_tool


class IdaasHome extends WizContainer {

  componentName = 'IdaasHome';

  constructor(props) {
    super(props);
    
    const getPageQuery = () => parse(window.location.href.split("?")[1]);
    const { tk } = getPageQuery();
    this.state = {
        token:tk
    }
  }

  propsAndStateOnChange = {
    user: this._user.bind(this),
  }
  componentDidMount() {
    if(!this.state.token){
        this.jumpPage('replace', '/sign/login')
    }
  }
  _user(nextProps, nextState){

    let { user } = nextProps
    if ( user?.id) {
        this.jumpPage('replace', '/home')
      return false;
    }else{
      return false;
    }
  }
  componentWillMount() {}
  
  _render() {
    return (
      <WizLayout className='manager-home'>
        <img src={constants.files.sys_main_logo} style={{width:'200px'}} />
      </WizLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
    const { user } = state;
  return {user};
};

export default connect(mapStateToProps)(IdaasHome);
